import {userConstants} from '../../_constants';

export function searchByOtherOwn(state = {}, action) {
  switch (action.type) {
    case userConstants.SEARCH_BY_OTHER_OWN_REQUEST:
      return {
        loading: true,
      };
    case userConstants.SEARCH_BY_OTHER_OWN_SUCCESS:
      return {
        ...action.data,
      };
    case userConstants.SEARCH_BY_OTHER_OWN_FAILURE:
      return {
        error: action.error,
      };
    case userConstants.RESET_SEARCH_RESULTS:
      return {};

    default:
      return state;
  }
}
